import type { Block } from 'src/__generated__/graphqlTypes';

import type { Blocks } from '../config/declarations';

export const parseContentfulBlocks = (blocks: Array<Block>) => (blocks || []).reduce(
  (store, block) => ({ ...store, [block.slug || 'content']: block }),
  {} as Blocks,
);
